export const Config = {
    appName: "PLACEm",
    appVersion: "19401",
};
